// Added by Sejune Oh on 2019-03-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Component } from 'react'
import { observer } from 'mobx-react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { ReactInputChangeEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Component
import NormalInput, { NormalInputFieldBaseFCProps } from './NormalInput'

interface NormalInputFieldCProps extends NormalInputFieldBaseFCProps {
    onChange?: Function
}

@observer
class NormalInputFieldContainer extends Component<NormalInputFieldCProps> {
    render() {
        const { type, min, max, step, onChange, curValue, ...props } = this.props
        return <NormalInput onChange={this._handleChange} inputProps={{ type, min, max, step, curvalue: curValue }} {...props} />
    }

    _handleChange: ReactInputChangeEvent = (e) => {
        const { type, curValue, onChange, id } = this.props
        const { target: { value } } = e

        // Number 인 케이스만 처리해야함. (React에서 Number type의 Input을 처리하는 버그)
        // https://stackoverflow.com/questions/42120888/react-controlled-number-input-jumps-when-deleting-decimal-point
        if (type === 'number') {
            const regex = new RegExp(/^-?\d*\.?\d*$/)
            if (regex.test(value)) {
                return onChange!(e)
            } else {
                this._handleError(id!, `${curValue}`)
                return
            }
        }

        return onChange!(e)
    }

    _handleError = (domId: string, curValue: string) => {
        ; (document.getElementById(domId) as HTMLInputElement).value = curValue
        return
    }
}

export default NormalInputFieldContainer
